/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchedPressRelease,
    SearchedPressReleaseFromJSON,
    SearchedPressReleaseFromJSONTyped,
    SearchedPressReleaseToJSON,
} from './SearchedPressRelease';

/**
 * 
 * @export
 * @interface SearchedPressReleasesResponseAllOfData
 */
export interface SearchedPressReleasesResponseAllOfData {
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof SearchedPressReleasesResponseAllOfData
     */
    nextCursor?: string;
    /**
     * 検索したプレスリリース一覧
     * @type {Array<SearchedPressRelease>}
     * @memberof SearchedPressReleasesResponseAllOfData
     */
    pressReleases: Array<SearchedPressRelease>;
    /**
     * 検索結果の総数
     * @type {number}
     * @memberof SearchedPressReleasesResponseAllOfData
     */
    totalCount: number;
}

export function SearchedPressReleasesResponseAllOfDataFromJSON(json: any): SearchedPressReleasesResponseAllOfData {
    return SearchedPressReleasesResponseAllOfDataFromJSONTyped(json, false);
}

export function SearchedPressReleasesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchedPressReleasesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
        'pressReleases': ((json['press_releases'] as Array<any>).map(SearchedPressReleaseFromJSON)),
        'totalCount': json['total_count'],
    };
}

export function SearchedPressReleasesResponseAllOfDataToJSON(value?: SearchedPressReleasesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'next_cursor': value.nextCursor,
        'press_releases': ((value.pressReleases as Array<any>).map(SearchedPressReleaseToJSON)),
        'total_count': value.totalCount,
    };
}

